import React from "react";
import FooterDefault from "../../components/shared/footers/FooterDefault";
import HeaderDefaultVerify from "../../components/shared/headers/HeaderDefaultVerify";
import BreadCrumb from "../../components/elements/BreadCrumb";
import RegisterVarifyExisting from "../../components/partials/account/RegisterVarifyExisting";
import NavigationList from "../../components/shared/navigation/NavigationList";

const RegisterVarifyExistingPage = () => {
  const breadCrumb = [
   
  ];

  return (
    <div className="site-content">
          <HeaderDefaultVerify />
      <NavigationList />
      <div className="ps-page--my-account">
        <BreadCrumb breacrumb={breadCrumb} />
              <RegisterVarifyExisting />
      </div>
      <FooterDefault />
    </div>
  );
};

export default RegisterVarifyExistingPage;
